import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface DragHintProps {
  portal?: React.RefObject<any>;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const DragHint = React.forwardRef<HTMLDivElement, DragHintProps>((props, ref) => {
  const { portal, className, children, style, ...others } = props;

  const Component = (
    <div
      ref={ref}
      className={`k-drag-hint ${className || ''}`}
      {...others}
      style={{
        position: 'absolute',
        backgroundColor: 'white',
        border: '1px solid rgba(0, 0, 0, 0.2)',
        padding: '8px 12px',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        zIndex: 10000,
        pointerEvents: 'none',
        userSelect: 'none',
        display: 'none', // Initially hidden, will be shown during drag
        ...style,
      }}
    >
      {children}
    </div>
  );

  return portal && portal.current && portal.current.element
    ? ReactDOM.createPortal(Component, portal.current.element)
    : Component;
});

DragHint.displayName = 'DragHint';

export default DragHint;